import { State } from 'src/types'
import { hamidashiOfNormal } from 'src/features/atoms/glove/drawer/rightThrow/glove/back//hamidashi/normal'
import { middleFingerLeft, middleFingerRight } from 'src/features/dxm/drawer/rightThrow/glove/back/middleFinger'
import { ringFingerLeft, ringFingerRight } from 'src/features/dxm/drawer/rightThrow/glove/back/ringFinger'
import { indexFingerLeft, indexFingerRight } from 'src/features/dxm/drawer/rightThrow/glove/back//indexFinger'
import { littleFingerLeft, littleFingerRight } from 'src/features/dxm/drawer/rightThrow/glove/back//littleFinger'
import { thumbAndListBelt, thumbOut } from 'src/features/dxm/drawer/rightThrow/glove/back//thumbAndListBelt'
import { listBelt } from 'src/features/dxm/drawer/rightThrow/glove/back//listBelt'
import { indexFingerPad } from 'src/features/dxm/drawer/rightThrow/glove/back//fingerCoverOrPad/indexFingerPad'
import { fingerCrotch } from 'src/features/dxm/drawer/rightThrow/glove/back//fingerCrotch'
import { catchFace } from 'src/features/dxm/drawer/rightThrow/glove/back//catchFace'
import { edgeOfBeltBackStyle } from 'src/features/dxm/drawer/rightThrow/glove/back//edge/edgeOfBeltBackstyle'
import { edgeOfWrist } from 'src/features/dxm/drawer/rightThrow/glove/back//edge/edgeOfWrist'
import { middleFingerPad } from 'src/features/dxm/drawer/rightThrow/glove/back//fingerCoverOrPad/middleFIngerPad'
import { startInversion, thumbEmbroideryDrawerLeftThrow, undoInversion } from 'src/util/canvas'

// 通常ベルトモデル
export const beltBackStyleDrawerLeftThrow = (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean, canvasWidth: number): void => {
  if (['crownBackStyle', 'firstBackStyle'].includes(state.backStyle?.value)) return
  if (['crownBackStyle', 'firstBackStyle'].includes(state.baseModel?.backStyle)) return
  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)
  const isMiddleFingerPad = ['middlePad'].includes(state.fingerGuardType?.value)

  startInversion(ctx, canvasWidth)
  thumbAndListBelt(ctx, state.thumbWeb?.color, state.stitch?.color)
  thumbOut(ctx, state.thumbOut?.color) // 親指＿外

  // 人差し指＿右... UBackここで描いてる
  indexFingerRight(ctx, state, needCatchFaceWrap)
  // 手首ベルト
  const isGorilla001Model = state.baseModel.productNumber === '001-20'
  const isBelt = ['normal', 'unselected', undefined].includes(state.beltType?.value) && !isGorilla001Model
  if (isBelt) {
    listBelt(ctx, state.listBelt?.color, state.stitch?.color)
  }
  // 人差し指＿左
  indexFingerLeft(ctx, state.indexMiddle?.color)
  // 中指＿右
  middleFingerRight(ctx, state.middleIndex?.color)
  // 中指＿左
  middleFingerLeft(ctx, state.middleRing?.color)

  // 薬指＿右
  ringFingerRight(ctx, state.ringMiddle?.color)
  // 薬指＿左
  ringFingerLeft(ctx, state.ringLittle?.color)

  // 小指＿右
  littleFingerRight(ctx, state.littleRing?.color)
  // 小指＿左
  littleFingerLeft(ctx, state.littleOut?.color)

  // ハミダシ
  hamidashiOfNormal(ctx, state.hamidashi?.color)

  // 捕球面 / ウェブ下折り返し
  catchFace(ctx, state.catchFace?.color, state.stitch?.color, needCatchFaceWrap)

  // ヘリ革
  edgeOfBeltBackStyle(ctx, state.edge?.color, state.stitch?.color)
  edgeOfWrist(ctx, state.edge?.color, state.stitch?.color)

  // 指当て(人指し指)
  isIndexFingerPad && indexFingerPad(ctx, state.indexCover.color, state.stitch.color)
  // 指当て(中指)
  isMiddleFingerPad && middleFingerPad(ctx, state.indexCover.color, state.stitch.color, -165, 90, -15)
  // 指股
  fingerCrotch(ctx, state.catchFace?.color, state.hamidashi?.color, state.baseModel?.isFingerCrotch)
  undoInversion(ctx, canvasWidth)
  thumbEmbroideryDrawerLeftThrow(ctx, state.embroideries, state.backStyle)
  //
}
